import createRequest from '../core/request'

/**
 * 异步任务 查询接口
 * @param {*} params
 * @returns
 */
export function async_task_query(params) {
  return createRequest('SyncAPI').get('/async/task_list', {
    params
  })
}

/**
 * 异步任务 提交任务
 * @param {*} params
 * @returns
 */
export function submit_batch_task(params, data) {
  return createRequest('SyncAPI').post('/async/submit_batch_task', data, {
    params
  })
}

/**
 * 异步任务 删除任务
 * @param {*} params
 * @returns
 */
export function delete_task(params, data) {
  return createRequest('SyncAPI').post('/async/delete_task', data, {
    params
  })
}

/**
 * 清空已完成的任务列表
 */
export function batch_delete_task(params) {
  return createRequest('SyncAPI').get('/async/batch_delete_task', {
    params
  })
}

/**
 * 查看异步任务失败详情
 */
export function view_task_result_detail(params) {
  return createRequest('SyncAPI').get('/async/task_detail', {
    params
  })
}
